// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__7EA4h","dragIcon":"SortableItem_dragIcon__29mrb","disabled":"SortableItem_disabled__3BQLb"};